import { useState, useCallback, useEffect } from "react";
import { debounce } from "lodash";

const getScreenSize = () => ({
  screenWidth:
    globalThis.window?.innerWidth ||
    globalThis.document?.documentElement.clientWidth ||
    globalThis.document?.body.clientWidth,
  screenHeight:
    globalThis.window?.innerHeight ||
    globalThis.document?.documentElement.clientHeight ||
    globalThis.document?.body.clientHeight
});

const useScreenSize = (): {
  screenWidth: number;
  screenHeight: number;
  isResponsive: boolean;
} => {
  const [mounted, setMounted] = useState(false);

  const [parameters, setParameters] = useState<{
    screenWidth: number;
    screenHeight: number;
  }>(getScreenSize());

  const handleUpdateScreen = useCallback(
    debounce(() => {
      setParameters(getScreenSize());
    }, 50),
    []
  );

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (mounted)
      globalThis.window?.addEventListener("resize", handleUpdateScreen);

    return () => {
      if (mounted)
        globalThis.window?.removeEventListener("resize", handleUpdateScreen);
    };
  }, [handleUpdateScreen, globalThis.window, mounted]);

  return { ...parameters, isResponsive: parameters.screenWidth < 1024 };
};

export default useScreenSize;
